import { fetcher, getHeaders } from './common';

const API_URL = '/api/AppSetting/';

export const getAppSetting = async () => {
	const headers = getHeaders(null);
	try {
		const response = await fetcher(API_URL + `/2`, 'GET', headers);

		const dataToReturn = await response.json();

		if (response.status === 400) {
			return { error: dataToReturn };
		}
		return dataToReturn;
	} catch (error) {
		console.log(error);
		return error;
	}
};
